// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/rollapp/tx.proto (package dymensionxyz.dymension.rollapp, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Coin } from "../../cosmos/base/v1beta1/coin_pb.js";
import { RollappMetadata } from "./metadata_pb.js";
import { GenesisInfo } from "./genesis_info_pb.js";
import { Rollapp_VMType } from "./rollapp_pb.js";
import { BlockDescriptors } from "./block_descriptor_pb.js";

/**
 * MsgCreateRollapp creates a new rollapp chain on the hub.
 *
 * @generated from message dymensionxyz.dymension.rollapp.MsgCreateRollapp
 */
export class MsgCreateRollapp extends Message<MsgCreateRollapp> {
  /**
   * creator is the bech32-encoded address of the rollapp creator
   *
   * @generated from field: string creator = 1;
   */
  creator = "";

  /**
   * rollappId is the unique identifier of the rollapp chain.
   * The rollapp_id follows the same standard as cosmos chain_id
   *
   * @generated from field: string rollapp_id = 2;
   */
  rollappId = "";

  /**
   * initial_sequencer takes one or more coma-separated bech32-encoded addresses of the
   * sequencer(s) that are allowed to initially serve this rollappId.
   *
   * @generated from field: string initial_sequencer = 11;
   */
  initialSequencer = "";

  /**
   * see Rollapp for more details
   *
   * @generated from field: cosmos.base.v1beta1.Coin min_sequencer_bond = 16;
   */
  minSequencerBond?: Coin;

  /**
   * alias is the chain alias used for display and namespace system
   *
   * @generated from field: string alias = 12;
   */
  alias = "";

  /**
   * metadata is the rollapp metadata
   *
   * @generated from field: dymensionxyz.dymension.rollapp.RollappMetadata metadata = 13;
   */
  metadata?: RollappMetadata;

  /**
   * genesis_info is the genesis information
   *
   * @generated from field: dymensionxyz.dymension.rollapp.GenesisInfo genesis_info = 14;
   */
  genesisInfo?: GenesisInfo;

  /**
   * vm_type is the type of rollapp machine: EVM or WASM
   *
   * @generated from field: dymensionxyz.dymension.rollapp.Rollapp.VMType vm_type = 15;
   */
  vmType = Rollapp_VMType.Unspecified;

  constructor(data?: PartialMessage<MsgCreateRollapp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgCreateRollapp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "initial_sequencer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "min_sequencer_bond", kind: "message", T: Coin },
    { no: 12, name: "alias", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "metadata", kind: "message", T: RollappMetadata },
    { no: 14, name: "genesis_info", kind: "message", T: GenesisInfo },
    { no: 15, name: "vm_type", kind: "enum", T: proto3.getEnumType(Rollapp_VMType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgCreateRollapp {
    return new MsgCreateRollapp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgCreateRollapp {
    return new MsgCreateRollapp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgCreateRollapp {
    return new MsgCreateRollapp().fromJsonString(jsonString, options);
  }

  static equals(a: MsgCreateRollapp | PlainMessage<MsgCreateRollapp> | undefined, b: MsgCreateRollapp | PlainMessage<MsgCreateRollapp> | undefined): boolean {
    return proto3.util.equals(MsgCreateRollapp, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.MsgCreateRollappResponse
 */
export class MsgCreateRollappResponse extends Message<MsgCreateRollappResponse> {
  constructor(data?: PartialMessage<MsgCreateRollappResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgCreateRollappResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgCreateRollappResponse {
    return new MsgCreateRollappResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgCreateRollappResponse {
    return new MsgCreateRollappResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgCreateRollappResponse {
    return new MsgCreateRollappResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgCreateRollappResponse | PlainMessage<MsgCreateRollappResponse> | undefined, b: MsgCreateRollappResponse | PlainMessage<MsgCreateRollappResponse> | undefined): boolean {
    return proto3.util.equals(MsgCreateRollappResponse, a, b);
  }
}

/**
 * MsgUpdateRollappInformation updates the rollapp information.
 *
 * @generated from message dymensionxyz.dymension.rollapp.MsgUpdateRollappInformation
 */
export class MsgUpdateRollappInformation extends Message<MsgUpdateRollappInformation> {
  /**
   * owner is the bech32-encoded address of the rollapp owner
   *
   * @generated from field: string owner = 1;
   */
  owner = "";

  /**
   * rollapp_id is the unique identifier of the rollapp chain.
   *
   * @generated from field: string rollapp_id = 2;
   */
  rollappId = "";

  /**
   * initial_sequencer is one or more bech32-encoded address of the
   * sequencer that are allowed to initially serve this rollappId.
   * wildcard '*' means any sequencer is allowed to be the first proposer.
   *
   * @generated from field: string initial_sequencer = 3;
   */
  initialSequencer = "";

  /**
   * see Rollapp for more details
   *
   * @generated from field: cosmos.base.v1beta1.Coin min_sequencer_bond = 7;
   */
  minSequencerBond?: Coin;

  /**
   * metadata is the rollapp metadata
   *
   * @generated from field: dymensionxyz.dymension.rollapp.RollappMetadata metadata = 5;
   */
  metadata?: RollappMetadata;

  /**
   * genesis_info is the genesis information
   *
   * @generated from field: dymensionxyz.dymension.rollapp.GenesisInfo genesis_info = 6;
   */
  genesisInfo?: GenesisInfo;

  constructor(data?: PartialMessage<MsgUpdateRollappInformation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgUpdateRollappInformation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "initial_sequencer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "min_sequencer_bond", kind: "message", T: Coin },
    { no: 5, name: "metadata", kind: "message", T: RollappMetadata },
    { no: 6, name: "genesis_info", kind: "message", T: GenesisInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgUpdateRollappInformation {
    return new MsgUpdateRollappInformation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgUpdateRollappInformation {
    return new MsgUpdateRollappInformation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgUpdateRollappInformation {
    return new MsgUpdateRollappInformation().fromJsonString(jsonString, options);
  }

  static equals(a: MsgUpdateRollappInformation | PlainMessage<MsgUpdateRollappInformation> | undefined, b: MsgUpdateRollappInformation | PlainMessage<MsgUpdateRollappInformation> | undefined): boolean {
    return proto3.util.equals(MsgUpdateRollappInformation, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.MsgUpdateRollappInformationResponse
 */
export class MsgUpdateRollappInformationResponse extends Message<MsgUpdateRollappInformationResponse> {
  constructor(data?: PartialMessage<MsgUpdateRollappInformationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgUpdateRollappInformationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgUpdateRollappInformationResponse {
    return new MsgUpdateRollappInformationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgUpdateRollappInformationResponse {
    return new MsgUpdateRollappInformationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgUpdateRollappInformationResponse {
    return new MsgUpdateRollappInformationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgUpdateRollappInformationResponse | PlainMessage<MsgUpdateRollappInformationResponse> | undefined, b: MsgUpdateRollappInformationResponse | PlainMessage<MsgUpdateRollappInformationResponse> | undefined): boolean {
    return proto3.util.equals(MsgUpdateRollappInformationResponse, a, b);
  }
}

/**
 * MsgUpdateState updates a rollapp state with a block batch.
 * a block batch is a list of ordered blocks (by height)
 *
 * @generated from message dymensionxyz.dymension.rollapp.MsgUpdateState
 */
export class MsgUpdateState extends Message<MsgUpdateState> {
  /**
   * creator is the bech32-encoded address of the sequencer sending the update
   *
   * @generated from field: string creator = 1;
   */
  creator = "";

  /**
   * rollappId is the rollapp that the sequencer belongs to and asking to update
   * The rollappId follows the same standard as cosmos chain_id
   *
   * @generated from field: string rollappId = 2;
   */
  rollappId = "";

  /**
   * startHeight is the block height of the first block in the batch
   *
   * @generated from field: uint64 startHeight = 3;
   */
  startHeight = protoInt64.zero;

  /**
   * numBlocks is the number of blocks included in this batch update
   *
   * @generated from field: uint64 numBlocks = 4;
   */
  numBlocks = protoInt64.zero;

  /**
   * DAPath is the description of the location on the DA layer
   *
   * @generated from field: string DAPath = 5;
   */
  DAPath = "";

  /**
   * BDs is a list of block description objects (one per block)
   * the list must be ordered by height, starting from startHeight to startHeight+numBlocks-1
   *
   * @generated from field: dymensionxyz.dymension.rollapp.BlockDescriptors BDs = 7;
   */
  BDs?: BlockDescriptors;

  /**
   * last is true if this is the last batch of the sequencer
   *
   * @generated from field: bool last = 8;
   */
  last = false;

  /**
   * rollapp_revision is the revision of the rollapp chain. increases after hard fork
   *
   * @generated from field: uint64 rollapp_revision = 9;
   */
  rollappRevision = protoInt64.zero;

  constructor(data?: PartialMessage<MsgUpdateState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgUpdateState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rollappId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "startHeight", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "numBlocks", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "DAPath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "BDs", kind: "message", T: BlockDescriptors },
    { no: 8, name: "last", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "rollapp_revision", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgUpdateState {
    return new MsgUpdateState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgUpdateState {
    return new MsgUpdateState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgUpdateState {
    return new MsgUpdateState().fromJsonString(jsonString, options);
  }

  static equals(a: MsgUpdateState | PlainMessage<MsgUpdateState> | undefined, b: MsgUpdateState | PlainMessage<MsgUpdateState> | undefined): boolean {
    return proto3.util.equals(MsgUpdateState, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.MsgUpdateStateResponse
 */
export class MsgUpdateStateResponse extends Message<MsgUpdateStateResponse> {
  constructor(data?: PartialMessage<MsgUpdateStateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgUpdateStateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgUpdateStateResponse {
    return new MsgUpdateStateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgUpdateStateResponse {
    return new MsgUpdateStateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgUpdateStateResponse {
    return new MsgUpdateStateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgUpdateStateResponse | PlainMessage<MsgUpdateStateResponse> | undefined, b: MsgUpdateStateResponse | PlainMessage<MsgUpdateStateResponse> | undefined): boolean {
    return proto3.util.equals(MsgUpdateStateResponse, a, b);
  }
}

/**
 * MsgTransferOwnership transfers the ownership of a rollapp chain to a new owner.
 *
 * @generated from message dymensionxyz.dymension.rollapp.MsgTransferOwnership
 */
export class MsgTransferOwnership extends Message<MsgTransferOwnership> {
  /**
   * current_owner is the bech32-encoded address of the current owner
   *
   * @generated from field: string current_owner = 1;
   */
  currentOwner = "";

  /**
   * new_owner is the bech32-encoded address of the new owner
   *
   * @generated from field: string new_owner = 2;
   */
  newOwner = "";

  /**
   * rollapp_id is the unique identifier of the rollapp chain.
   *
   * @generated from field: string rollapp_id = 3;
   */
  rollappId = "";

  constructor(data?: PartialMessage<MsgTransferOwnership>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgTransferOwnership";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "current_owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgTransferOwnership {
    return new MsgTransferOwnership().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgTransferOwnership {
    return new MsgTransferOwnership().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgTransferOwnership {
    return new MsgTransferOwnership().fromJsonString(jsonString, options);
  }

  static equals(a: MsgTransferOwnership | PlainMessage<MsgTransferOwnership> | undefined, b: MsgTransferOwnership | PlainMessage<MsgTransferOwnership> | undefined): boolean {
    return proto3.util.equals(MsgTransferOwnership, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.MsgTransferOwnershipResponse
 */
export class MsgTransferOwnershipResponse extends Message<MsgTransferOwnershipResponse> {
  constructor(data?: PartialMessage<MsgTransferOwnershipResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgTransferOwnershipResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgTransferOwnershipResponse {
    return new MsgTransferOwnershipResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgTransferOwnershipResponse {
    return new MsgTransferOwnershipResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgTransferOwnershipResponse {
    return new MsgTransferOwnershipResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgTransferOwnershipResponse | PlainMessage<MsgTransferOwnershipResponse> | undefined, b: MsgTransferOwnershipResponse | PlainMessage<MsgTransferOwnershipResponse> | undefined): boolean {
    return proto3.util.equals(MsgTransferOwnershipResponse, a, b);
  }
}

/**
 * MsgAddApp adds an app to the rollapp.
 *
 * @generated from message dymensionxyz.dymension.rollapp.MsgAddApp
 */
export class MsgAddApp extends Message<MsgAddApp> {
  /**
   * creator is the bech32-encoded address of the app creator
   *
   * @generated from field: string creator = 1;
   */
  creator = "";

  /**
   * name is the unique App's name
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * rollapp_id is the id of the Rollapp the App belongs to
   *
   * @generated from field: string rollapp_id = 3;
   */
  rollappId = "";

  /**
   * description is the description of the App
   *
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * image is the url to the App image
   *
   * @generated from field: string image = 5;
   */
  image = "";

  /**
   * url is the URL to the App's website
   *
   * @generated from field: string url = 6;
   */
  url = "";

  /**
   * order is the order of the App in the Rollapp
   *
   * @generated from field: int32 order = 7;
   */
  order = 0;

  constructor(data?: PartialMessage<MsgAddApp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgAddApp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgAddApp {
    return new MsgAddApp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgAddApp {
    return new MsgAddApp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgAddApp {
    return new MsgAddApp().fromJsonString(jsonString, options);
  }

  static equals(a: MsgAddApp | PlainMessage<MsgAddApp> | undefined, b: MsgAddApp | PlainMessage<MsgAddApp> | undefined): boolean {
    return proto3.util.equals(MsgAddApp, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.MsgAddAppResponse
 */
export class MsgAddAppResponse extends Message<MsgAddAppResponse> {
  constructor(data?: PartialMessage<MsgAddAppResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgAddAppResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgAddAppResponse {
    return new MsgAddAppResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgAddAppResponse {
    return new MsgAddAppResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgAddAppResponse {
    return new MsgAddAppResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgAddAppResponse | PlainMessage<MsgAddAppResponse> | undefined, b: MsgAddAppResponse | PlainMessage<MsgAddAppResponse> | undefined): boolean {
    return proto3.util.equals(MsgAddAppResponse, a, b);
  }
}

/**
 * MsgUpdateApp updates the app information.
 *
 * @generated from message dymensionxyz.dymension.rollapp.MsgUpdateApp
 */
export class MsgUpdateApp extends Message<MsgUpdateApp> {
  /**
   * creator is the bech32-encoded address of the app owner
   *
   * @generated from field: string creator = 1;
   */
  creator = "";

  /**
   * id is the unique App's id in the Rollapp
   *
   * @generated from field: uint64 id = 2;
   */
  id = protoInt64.zero;

  /**
   * name is the unique App's name (immutable)
   *
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * rollapp_id is the id of the Rollapp the App belongs to
   *
   * @generated from field: string rollapp_id = 4;
   */
  rollappId = "";

  /**
   * description is the description of the App
   *
   * @generated from field: string description = 5;
   */
  description = "";

  /**
   * image is the url to the App image
   *
   * @generated from field: string image = 6;
   */
  image = "";

  /**
   * url is the URL to the App's website
   *
   * @generated from field: string url = 7;
   */
  url = "";

  /**
   * order is the order of the App in the Rollapp
   *
   * @generated from field: int32 order = 8;
   */
  order = 0;

  constructor(data?: PartialMessage<MsgUpdateApp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgUpdateApp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgUpdateApp {
    return new MsgUpdateApp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgUpdateApp {
    return new MsgUpdateApp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgUpdateApp {
    return new MsgUpdateApp().fromJsonString(jsonString, options);
  }

  static equals(a: MsgUpdateApp | PlainMessage<MsgUpdateApp> | undefined, b: MsgUpdateApp | PlainMessage<MsgUpdateApp> | undefined): boolean {
    return proto3.util.equals(MsgUpdateApp, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.MsgUpdateAppResponse
 */
export class MsgUpdateAppResponse extends Message<MsgUpdateAppResponse> {
  constructor(data?: PartialMessage<MsgUpdateAppResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgUpdateAppResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgUpdateAppResponse {
    return new MsgUpdateAppResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgUpdateAppResponse {
    return new MsgUpdateAppResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgUpdateAppResponse {
    return new MsgUpdateAppResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgUpdateAppResponse | PlainMessage<MsgUpdateAppResponse> | undefined, b: MsgUpdateAppResponse | PlainMessage<MsgUpdateAppResponse> | undefined): boolean {
    return proto3.util.equals(MsgUpdateAppResponse, a, b);
  }
}

/**
 * MsgRemoveApp removes an app from the rollapp.
 *
 * @generated from message dymensionxyz.dymension.rollapp.MsgRemoveApp
 */
export class MsgRemoveApp extends Message<MsgRemoveApp> {
  /**
   * creator is the bech32-encoded address of the app owner
   *
   * @generated from field: string creator = 1;
   */
  creator = "";

  /**
   * id is the unique App's id in the Rollapp
   *
   * @generated from field: uint64 id = 2;
   */
  id = protoInt64.zero;

  /**
   * rollapp_id is the id of the Rollapp the App belongs to
   *
   * @generated from field: string rollapp_id = 3;
   */
  rollappId = "";

  constructor(data?: PartialMessage<MsgRemoveApp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgRemoveApp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgRemoveApp {
    return new MsgRemoveApp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgRemoveApp {
    return new MsgRemoveApp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgRemoveApp {
    return new MsgRemoveApp().fromJsonString(jsonString, options);
  }

  static equals(a: MsgRemoveApp | PlainMessage<MsgRemoveApp> | undefined, b: MsgRemoveApp | PlainMessage<MsgRemoveApp> | undefined): boolean {
    return proto3.util.equals(MsgRemoveApp, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.MsgRemoveAppResponse
 */
export class MsgRemoveAppResponse extends Message<MsgRemoveAppResponse> {
  constructor(data?: PartialMessage<MsgRemoveAppResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgRemoveAppResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgRemoveAppResponse {
    return new MsgRemoveAppResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgRemoveAppResponse {
    return new MsgRemoveAppResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgRemoveAppResponse {
    return new MsgRemoveAppResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgRemoveAppResponse | PlainMessage<MsgRemoveAppResponse> | undefined, b: MsgRemoveAppResponse | PlainMessage<MsgRemoveAppResponse> | undefined): boolean {
    return proto3.util.equals(MsgRemoveAppResponse, a, b);
  }
}

/**
 * MsgMarkObsoleteRollapps marks specified versions as obsolete as well as
 * all corresponding rollapps. Must be called by the governance.
 *
 * @generated from message dymensionxyz.dymension.rollapp.MsgMarkObsoleteRollapps
 */
export class MsgMarkObsoleteRollapps extends Message<MsgMarkObsoleteRollapps> {
  /**
   * Authority is the authority address.
   *
   * @generated from field: string authority = 1;
   */
  authority = "";

  /**
   * DrsVersions is a list of DRS versions that will be marked obsolete.
   *
   * @generated from field: repeated uint32 drs_versions = 2;
   */
  drsVersions: number[] = [];

  constructor(data?: PartialMessage<MsgMarkObsoleteRollapps>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgMarkObsoleteRollapps";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "authority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "drs_versions", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgMarkObsoleteRollapps {
    return new MsgMarkObsoleteRollapps().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgMarkObsoleteRollapps {
    return new MsgMarkObsoleteRollapps().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgMarkObsoleteRollapps {
    return new MsgMarkObsoleteRollapps().fromJsonString(jsonString, options);
  }

  static equals(a: MsgMarkObsoleteRollapps | PlainMessage<MsgMarkObsoleteRollapps> | undefined, b: MsgMarkObsoleteRollapps | PlainMessage<MsgMarkObsoleteRollapps> | undefined): boolean {
    return proto3.util.equals(MsgMarkObsoleteRollapps, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.MsgMarkObsoleteRollappsResponse
 */
export class MsgMarkObsoleteRollappsResponse extends Message<MsgMarkObsoleteRollappsResponse> {
  constructor(data?: PartialMessage<MsgMarkObsoleteRollappsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.MsgMarkObsoleteRollappsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgMarkObsoleteRollappsResponse {
    return new MsgMarkObsoleteRollappsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgMarkObsoleteRollappsResponse {
    return new MsgMarkObsoleteRollappsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgMarkObsoleteRollappsResponse {
    return new MsgMarkObsoleteRollappsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgMarkObsoleteRollappsResponse | PlainMessage<MsgMarkObsoleteRollappsResponse> | undefined, b: MsgMarkObsoleteRollappsResponse | PlainMessage<MsgMarkObsoleteRollappsResponse> | undefined): boolean {
    return proto3.util.equals(MsgMarkObsoleteRollappsResponse, a, b);
  }
}

